<template>
        <ul class="pagination" role="navigation" aria-label="Pagination" v-if="total && total > 1">
            <li><a href="#" @click.prevent="goBack" class="pagination-previous" :class="{ disabled: isFirst }" aria-label="Iepriekšējā lapa"><svg-icon :symbol="previousIcon" :originalDims="true"></svg-icon><span class="show-for-sr">Iepriekšējā lapa</span></a></li>
            <template v-if="visibleRange[0] > 2">
                <li><a href="#" @click.prevent="setCurrent(1)" aria-label="Lapa 1">1</a></li>
                <li aria-hidden="true"><span class="ellipsis"></span></li>
            </template>
            <li v-for="num in visibleRange" :key="num">
                <span v-if="current == num" :class="{ current: (current == num) }">{{ num }}</span>
                <a v-else @click.prevent="setCurrent(num)" :aria-label="'Lapa ' + num">{{ num }}</a>
            </li>
            <template v-if="visibleRange[visibleRange.length - 1] != total">
                <li aria-hidden="true"><span class="ellipsis"></span></li>
                <li><a href="#" @click.prevent="setCurrent(total)" :aria-label="'Lapa ' + total">{{ total }}</a></li>
            </template>
            <li><a href="#" @click.prevent="goForward" class="pagination-next" :class="{ disabled: isLast }" aria-label="Nākamā lapa"><svg-icon :symbol="nextIcon" :originalDims="true"></svg-icon><span class="show-for-sr">Nākamā lapa</span></a></li>
        </ul>
</template>

<script>
    import SvgIcon from '../SvgIcon'
    import previousIcon from '../../../icons/icon-previous.svg-sprite'
    import nextIcon from '../../../icons/icon-next.svg-sprite'

    function range(begin, end) {
        let list = [];
        for (let i = begin; i <= end; i++) list.push(i);
        return list;
    }

    export default {

        props: ['current', 'total'],

        data: function () {
            return {
                'visiblePages': 9,
                previousIcon,
                nextIcon
            }
        },

        methods: {

            setCurrent(val) {
                this.$emit('update:current', val)
            },

            goBack() {
                if (this.current <= 1) return;
                this.setCurrent(this.current - 1);
            },

            goForward() {
                if (this.current >= this.total) return;
                this.setCurrent(this.current + 1);
            }
        },

        computed: {

            visibleRange() {

                const skipLength = 2;
                const offset = Math.floor(this.visiblePages / 2);

                let offsetMin = this.current - offset;
                let offsetMax = this.current + offset;

                // Adjust inner range offset if below 1 or above total page count
                if (offsetMin < 1) offsetMax += 1 + Math.abs(offsetMin);
                if (offsetMax > this.total) offsetMin -= Math.abs(this.total - offsetMax);

                let rangeMin = Math.max(1, offsetMin);
                let rangeMax = Math.min(this.total, offsetMax);

                // Adjust range before we can show skip to first or skip to last
                // (to avoid 1 - .. - 2 or even 1 - .. - 3 which is not good ux)
                if (rangeMin > 1 && rangeMin < 1 + skipLength) {
                    const shift = rangeMin - 1;
                    rangeMax -= shift;
                    rangeMin -= shift;
                }

                if (rangeMax < this.total && rangeMax > (this.total - skipLength)) {
                    const shift = this.total - rangeMax;
                    rangeMin += shift;
                    rangeMax += shift;
                }

                // Reduce visible range on account of skip to first and skip to last sub-range length
                if (rangeMin > 1) {
                    rangeMin += skipLength;
                }

                if (rangeMax < this.total) {
                    rangeMax -= skipLength;
                }

                return range(rangeMin, rangeMax);
            },

            isFirst() {
                return this.current === 1;
            },

            isLast() {
                return this.current === this.total;
            }
        },

        components: {SvgIcon}

    }
</script>

<style lang="scss" scoped="">
    @import "../../../sass/settings";
    @import "../../../sass/mixins";
    @import "../../../sass/foundation/config";

    .pagination {
        font-weight: 700;
        line-height: 1;
        display: inline-flex;
        flex-wrap: nowrap;
        justify-content: center;
        border: 1px solid $color-iron-gray;
        border-radius: 2px;
        overflow: hidden;

        > li {
            background-color: white;
            border-radius: 0;
            display: block;

            > a,
            > span {
                display: block;
                min-width: rem-calc(70px);
                text-align: center;
            }

            > span {
                padding: 1.8125rem 1.25rem;
            }

            .ellipsis:after {
                padding: 0;
            }

            &:not(:last-child) {
                border-right: 1px solid $color-concrete-gray;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/Pagination.vue